import { useRef, useState } from "react";
import moment from "moment";

export const useQuickSaleList = (initialQuickSales = [], ITEMS_PER_PAGE) => {
  const isFirstRender = useRef(true);
  const firstRender = isFirstRender.current;

  const initialData =
    firstRender && initialQuickSales?.length
      ? initialQuickSales.slice(0, ITEMS_PER_PAGE)
      : [];

  const [state, setState] = useState({
    isLoading: true,
    quickSaleList: initialData,
    totalPaid: 0,
    totalUnPaid: 0,
    totalQuickSaleFilterCount: 0,
    totalQuickSaleAmount: 0,
  });

  const getDateRange = (date) => {
    return {
      start: date?.startDate
        ? moment(date.startDate).startOf("day").valueOf()
        : undefined,
      end: date?.endDate
        ? moment(date.endDate).endOf("day").valueOf()
        : undefined,
    };
  };

  const calculateTotals = (data) => {
    let totals = {
      totalFilteredCount: data?.length || 0,
      totalPaid: 0,
      totalUnPaid: 0,
      totalQuickSaleAmount: 0,
    };

    data.forEach((item) => {
      totals.totalQuickSaleAmount += item.amount;

      if (item.status === "paid") {
        totals.totalPaid += item.amount;
      } else {
        totals.totalUnPaid += item.amount - (item.advance_amount || 0);
      }
    });

    return totals;
  };

  const handleQuickSale = async ({
    business,
    filters,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    const { date, amount, category, method, sort, status, keywords } =
      filters || {};

    setState((prev) => ({ ...prev, isLoading: true }));

    const { start, end } = getDateRange(date);

    try {
      let totals = {};

      // Calculate totals
      if (isCalculateTotal) {
        let rawData;

        if (firstRender) {
          rawData = initialQuickSales;
        } else {
          const baseQuery = business.getQuickSale(
            start,
            end,
            keywords || "",
            status,
            undefined,
            undefined,
            undefined,
            amount,
            category,
            method,
          );

          rawData = await baseQuery.unsafeFetchRaw();
        }

        totals = calculateTotals(rawData);
      }

      // Fetch paginated list
      const paginatedItems = firstRender
        ? initialData
        : await business
            .getQuickSale(
              start,
              end,
              keywords || "",
              status,
              limit,
              offset,
              sort || "Newest",
              amount,
              category,
              method,
            )
            .fetch();

      const updatedList =
        offset > 0
          ? [...state.quickSaleList, ...paginatedItems]
          : paginatedItems;

      isFirstRender.current = false;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        quickSaleList: updatedList,
        ...(isCalculateTotal && {
          totalPaid: totals.totalPaid,
          totalUnPaid: totals.totalUnPaid,
          totalQuickSaleFilterCount: totals.totalFilteredCount,
          totalQuickSaleAmount: totals.totalQuickSaleAmount,
        }),
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { ...state, handleQuickSale };
};
